import React from 'react';

const Logo = ({ className = "h-8 w-8", showText = false, textClassName = "text-2xl font-bold text-primary-600" }) => {
  return (
    <div className="flex items-center gap-2">
      {/* Modern Minimal Logo - Target & Growth */}
      <svg
        className={className}
        viewBox="0 0 100 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Outer Circle - Target/Goal */}
        <circle
          cx="50"
          cy="50"
          r="40"
          stroke="url(#gradientMain)"
          strokeWidth="6"
          fill="none"
        />

        {/* Inner Circle */}
        <circle
          cx="50"
          cy="50"
          r="25"
          stroke="url(#gradientMain)"
          strokeWidth="4"
          fill="none"
          opacity="0.6"
        />

        {/* Center Dot - Bullseye */}
        <circle
          cx="50"
          cy="50"
          r="8"
          fill="url(#gradientAccent)"
        />

        {/* Upward Arrow - Progress */}
        <path
          d="M50 70 L50 30 M50 30 L40 40 M50 30 L60 40"
          stroke="url(#gradientAccent)"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />

        {/* Gradients */}
        <defs>
          <linearGradient id="gradientMain" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#3B82F6" />
            <stop offset="100%" stopColor="#8B5CF6" />
          </linearGradient>

          <linearGradient id="gradientAccent" x1="0%" y1="100%" x2="0%" y2="0%">
            <stop offset="0%" stopColor="#F59E0B" />
            <stop offset="100%" stopColor="#EF4444" />
          </linearGradient>
        </defs>
      </svg>

      {/* Text Logo */}
      {showText && (
        <span className={textClassName}>
          Deneme <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary-600 to-purple-600">Koç</span>
        </span>
      )}
    </div>
  );
};

export default Logo;
